// Predefined, self-contained section templates (inline styles) for the section library.
// Inserted into the user's page via the editor runtime; fully editable afterwards.

const FONT = "font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;";

export const SECTION_TEMPLATES = [
  {
    id: "hero",
    name: "Hero",
    icon: "fa-star",
    html: `<section style="${FONT}padding:80px 24px;background:#0f172a;color:#fff;text-align:center;">
      <div style="max-width:800px;margin:0 auto;">
        <h1 style="font-size:48px;line-height:1.1;margin:0 0 16px;">Il tuo titolo qui</h1>
        <p style="font-size:20px;color:#cbd5e1;margin:0 0 32px;">Una breve frase che spiega cosa offri e perché è speciale.</p>
        <a href="#" style="display:inline-block;background:#00F0FF;color:#0a0a0a;font-weight:700;padding:14px 32px;border-radius:9999px;text-decoration:none;">Inizia ora</a>
      </div>
    </section>`,
  },
  {
    id: "features",
    name: "Caratteristiche",
    icon: "fa-grip",
    html: `<section style="${FONT}padding:72px 24px;background:#ffffff;color:#0f172a;">
      <div style="max-width:1000px;margin:0 auto;text-align:center;">
        <h2 style="font-size:34px;margin:0 0 48px;">Perché sceglierci</h2>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:24px;">
          <div style="padding:24px;border:1px solid #e2e8f0;border-radius:16px;"><h3 style="margin:0 0 8px;">Veloce</h3><p style="color:#475569;margin:0;">Descrizione del vantaggio numero uno.</p></div>
          <div style="padding:24px;border:1px solid #e2e8f0;border-radius:16px;"><h3 style="margin:0 0 8px;">Semplice</h3><p style="color:#475569;margin:0;">Descrizione del vantaggio numero due.</p></div>
          <div style="padding:24px;border:1px solid #e2e8f0;border-radius:16px;"><h3 style="margin:0 0 8px;">Affidabile</h3><p style="color:#475569;margin:0;">Descrizione del vantaggio numero tre.</p></div>
        </div>
      </div>
    </section>`,
  },
  {
    id: "pricing",
    name: "Prezzi",
    icon: "fa-tag",
    html: `<section style="${FONT}padding:72px 24px;background:#f8fafc;color:#0f172a;">
      <div style="max-width:980px;margin:0 auto;text-align:center;">
        <h2 style="font-size:34px;margin:0 0 48px;">Prezzi</h2>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:24px;">
          <div style="background:#fff;padding:32px;border:1px solid #e2e8f0;border-radius:16px;"><h3 style="margin:0;">Base</h3><div style="font-size:40px;font-weight:800;margin:12px 0;">€9<span style="font-size:16px;font-weight:400;">/mese</span></div><p style="color:#475569;">Per iniziare.</p></div>
          <div style="background:#0f172a;color:#fff;padding:32px;border-radius:16px;"><h3 style="margin:0;">Pro</h3><div style="font-size:40px;font-weight:800;margin:12px 0;">€29<span style="font-size:16px;font-weight:400;">/mese</span></div><p style="color:#cbd5e1;">Il più popolare.</p></div>
          <div style="background:#fff;padding:32px;border:1px solid #e2e8f0;border-radius:16px;"><h3 style="margin:0;">Business</h3><div style="font-size:40px;font-weight:800;margin:12px 0;">€99<span style="font-size:16px;font-weight:400;">/mese</span></div><p style="color:#475569;">Per i team.</p></div>
        </div>
      </div>
    </section>`,
  },
  {
    id: "team",
    name: "Team",
    icon: "fa-users",
    html: `<section style="${FONT}padding:72px 24px;background:#ffffff;color:#0f172a;">
      <div style="max-width:1000px;margin:0 auto;text-align:center;">
        <h2 style="font-size:34px;margin:0 0 48px;">Il nostro team</h2>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:24px;">
          <div><img src="https://i.pravatar.cc/200?img=12" style="width:120px;height:120px;border-radius:9999px;object-fit:cover;" alt=""><h3 style="margin:16px 0 4px;">Nome Cognome</h3><p style="color:#475569;margin:0;">Ruolo</p></div>
          <div><img src="https://i.pravatar.cc/200?img=32" style="width:120px;height:120px;border-radius:9999px;object-fit:cover;" alt=""><h3 style="margin:16px 0 4px;">Nome Cognome</h3><p style="color:#475569;margin:0;">Ruolo</p></div>
          <div><img src="https://i.pravatar.cc/200?img=5" style="width:120px;height:120px;border-radius:9999px;object-fit:cover;" alt=""><h3 style="margin:16px 0 4px;">Nome Cognome</h3><p style="color:#475569;margin:0;">Ruolo</p></div>
        </div>
      </div>
    </section>`,
  },
  {
    id: "gallery",
    name: "Galleria",
    icon: "fa-images",
    html: `<section style="${FONT}padding:72px 24px;background:#0f172a;color:#fff;">
      <div style="max-width:1000px;margin:0 auto;">
        <h2 style="font-size:34px;margin:0 0 32px;text-align:center;">Galleria</h2>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:16px;">
          <img src="https://picsum.photos/400/300?random=1" style="width:100%;height:200px;object-fit:cover;border-radius:12px;" alt="">
          <img src="https://picsum.photos/400/300?random=2" style="width:100%;height:200px;object-fit:cover;border-radius:12px;" alt="">
          <img src="https://picsum.photos/400/300?random=3" style="width:100%;height:200px;object-fit:cover;border-radius:12px;" alt="">
        </div>
      </div>
    </section>`,
  },
  {
    id: "contact",
    name: "Contatti",
    icon: "fa-envelope",
    html: `<section style="${FONT}padding:72px 24px;background:#ffffff;color:#0f172a;">
      <div style="max-width:560px;margin:0 auto;text-align:center;">
        <h2 style="font-size:34px;margin:0 0 12px;">Contattaci</h2>
        <p style="color:#475569;margin:0 0 32px;">Scrivici e ti risponderemo il prima possibile.</p>
        <div style="display:grid;gap:12px;text-align:left;">
          <input placeholder="Il tuo nome" style="padding:14px;border:1px solid #e2e8f0;border-radius:10px;font-size:16px;">
          <input placeholder="La tua email" style="padding:14px;border:1px solid #e2e8f0;border-radius:10px;font-size:16px;">
          <textarea placeholder="Messaggio" rows="4" style="padding:14px;border:1px solid #e2e8f0;border-radius:10px;font-size:16px;"></textarea>
          <button style="background:#0f172a;color:#fff;padding:14px;border:none;border-radius:10px;font-weight:700;font-size:16px;cursor:pointer;">Invia</button>
        </div>
      </div>
    </section>`,
  },
  {
    id: "cta",
    name: "Call to action",
    icon: "fa-bolt",
    html: `<section style="${FONT}padding:64px 24px;background:#00F0FF;color:#0a0a0a;text-align:center;">
      <div style="max-width:720px;margin:0 auto;">
        <h2 style="font-size:32px;margin:0 0 12px;">Pronto a iniziare?</h2>
        <p style="font-size:18px;margin:0 0 28px;">Unisciti a noi oggi stesso.</p>
        <a href="#" style="display:inline-block;background:#0a0a0a;color:#fff;font-weight:700;padding:14px 32px;border-radius:9999px;text-decoration:none;">Contattaci</a>
      </div>
    </section>`,
  },
];
